import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../features/userSlice';
import reservationReducer from '../features/reservationSlice';
import homeReducer  from '../features/homeSlice';
import productsReducer from '../features/productsSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    reservation: reservationReducer,
    home : homeReducer,
    products: productsReducer,
  },
});